import Vue from 'vue'
import VueLazyImageLoading from 'vue-lazy-image-loading'
import vuelineclamp from 'vue-line-clamp'
import share from 'vue-social-sharing'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import VueMasonry from 'vue-masonry-css'
import VueScrollTo from 'vue-scrollto'
import SitecoreVuePlugin from './plugins/sc-vue-adapter-plugin/vue-sc-plugin'

Vue.use(SitecoreVuePlugin)
Vue.use(VueScrollTo)
Vue.use(VueMasonry)
Vue.use(share)
Vue.use(VModal)
Vue.use(vuelineclamp)
Vue.use(VueLazyImageLoading)

// Initiate the sitecore vue plugin
Vue.use(VTooltip)

import 'picturefill'
import 'lazysizes'
import './utils/jsapi-youku'
import './utils/prototypes'

import { ValtechManager } from './utils/analytics'

import './utils/footer'
import './utils/anchor'
import './utils/onetrust-renew'

// Import Calculator Download State Store
import './utils/calculator-download-store'

// Lazy loading plugins & util for background image optimizations
import './plugins/ls.unveilhooks'
import './plugins/lazysizes-bgset'
import './utils/lazysizes-bg-init'

// Lazy loading tagging
import './plain/tagging'
import './plain/background-video'
import './plain/faq-page-structured-data'

// Import Components
// import VueLazyBackgroundImage from 'vue-lazy-background-images'
import vueclamp from 'vue-clamp'
import vSelect from 'vue-select'

import v2 from './components/00_v2'
import atoms from './components/02_atoms'
import molecules from './components/03_molecules'
import organisms from './components/04_organisms'

const components = [
  ...v2,
  ...atoms,
  ...molecules,
  ...organisms
]

// Vue Declaration for Components
// Vue.component('lazy-background', VueLazyBackgroundImage)
Vue.component('vClamp', vueclamp)
Vue.component('v-select', vSelect)

components.forEach(directive => {
  Vue.component(directive.name, directive)
})

import {
  backgroundDirective,
  loadscript,
  clickextension,
  analyticsconfig,
  ellipsis,
  openmodal,
  breakword,
  definesize,
  clickoutside,
} from './directives'

Vue.directive(ellipsis.name, ellipsis)
Vue.directive(backgroundDirective.name, backgroundDirective)
Vue.directive('loadscript', loadscript)
Vue.directive('clickextension', clickextension)
Vue.directive('analyticsConfig', analyticsconfig)
Vue.directive('openmodal', openmodal)
Vue.directive('breakword', breakword)
Vue.directive('definesize', definesize)
Vue.directive('clickoutside', clickoutside)

import store from './store'
import SitecoreVueAdapter from './plugins/sc-vue-adapter-plugin/sc-vue-adapter'

SitecoreVueAdapter.InitialiseVueApp(() => {
  new Vue({ // eslint-disable-line no-new
    el: '#main-container',
    store,
    mounted() {
      const $el = document.querySelector('.header--white,.header--ds')

      if ($el) {
        this.$el.style.paddingTop = `${$el.offsetHeight}px`
      }

      this.checkScroll()
      window.addEventListener('scroll', this.checkScroll.bind(this), {
        passive: false
      })
      document.body.addEventListener('scroll', this.checkScroll.bind(this), {
        passive: false
      })
      this.initializeDataLayer()
    },
    methods: {
      checkScroll() {
        this.$store.dispatch('updateScroll', this.$el.getBoundingClientRect().top)
      },
      initializeDataLayer() {
        window.digitalData = ValtechManager.init()
      }
    }
  })
})
